export const name = '@issuu/tracking-micro';
export const version = '18.0.2';
